module.exports = __webpack_public_path__ + "static/media/UpGraphIcon.5e124c44.svg";